import {
  Cookies,
  LocalStorage,
  SessionStorage,
} from "core-lib/constants/storage";
import { createMoengageEvent } from "core-lib/utils/eventTracking";
import dayjs from "dayjs";
import { useEffect } from "react";
import { v4 as uuid } from "uuid";

import useMoengageLoad from "../../hooks/useMoengageLoad";
import { useProfile } from "../../hooks/useProfile";
import { getCookieValue } from "../../utils/cookie";
import { isParkPlusWebView } from "../../utils/source";
import {isServer} from "../../utils/utils";

const EMSThreshold = 15 * 60 * 1000;

export const QueuedEvents = () => {
  const [isMoengageLoaded] = useMoengageLoad();
  // const [isGtagLoaded] = useGtagLoad();
  const { isAuthenticated, phoneNumber, isProfileLoaded, fullName, email } =
    useProfile();

  // React.useEffect(() => {
  //   const GtagQueuedEvents = sessionStorage.getItem(
  //     SessionStorage.GtagQueuedEvents
  //   );
  //   if (GtagQueuedEvents && isGtagLoaded) {
  //     const parsedQueuedEvents = JSON.parse(GtagQueuedEvents);
  //     if (Array.isArray(parsedQueuedEvents)) {
  //       parsedQueuedEvents.forEach((obj) => createGoogleTagEvent(obj));
  //     }
  //     sessionStorage.removeItem(SessionStorage.GtagQueuedEvents);
  //   }
  // }, [isGtagLoaded]);

  const addSessionTracker = () => {
    const obj = {
      created_at: Date.now(),
      session_id: uuid(),
    };
    localStorage.setItem(LocalStorage.SessionTracker, JSON.stringify(obj));
  };

  const checkSessionTracker = () => {
    if (!isParkPlusWebView() && isAuthenticated) {
      const sessionTracker = localStorage.getItem(LocalStorage.SessionTracker);
      if (!sessionTracker) {
        addSessionTracker();
      } else {
        const obj = JSON.parse(sessionTracker);
        // if diff > threshold, create and add new object to localStorage
        if (
          dayjs().diff(dayjs(obj.created_at, "millisecond")) >= EMSThreshold
        ) {
          addSessionTracker();
        }
      }
    }
  };

  useEffect(() => {
    checkSessionTracker();
  }, [isAuthenticated]);

  useEffect(() => {
    const queuedEvents = sessionStorage.getItem(
      SessionStorage.MoengageQueuedEvents
    );
    if (queuedEvents && isMoengageLoaded) {
      const parsedQueuedEvents = JSON.parse(queuedEvents);
      const eventsArr = Object.entries(parsedQueuedEvents);
      if (eventsArr?.length > 0) {
        eventsArr.forEach((item) => {
          const eventsObj = JSON.parse(
            sessionStorage.getItem(SessionStorage.MoengageQueuedEvents)
          );
          if (eventsObj?.[item?.[0]]) {
            delete eventsObj[item?.[0]];
            sessionStorage.setItem(
              SessionStorage.MoengageQueuedEvents,
              JSON.stringify(eventsObj)
            );
          }
          createMoengageEvent(item?.[1]);
        });
      }
    }
  }, [isMoengageLoaded]);

  useEffect(() => {
    if (isAuthenticated && isMoengageLoaded && isProfileLoaded) {
      let setPhoneNumber;
      if (phoneNumber) {
        setPhoneNumber = phoneNumber;
      } else {
        const authPhoneNumberL = getCookieValue(Cookies.AuthPhoneNo);
        if (authPhoneNumberL) setPhoneNumber = authPhoneNumberL;
      }
      if (setPhoneNumber) {
        // @ts-ignore
        if (!isServer() && global.Moengage)
          // @ts-ignore
          global.Moengage.add_unique_user_id(setPhoneNumber);
        // @ts-ignore
        global.Moengage.add_user_name(fullName);
        // @ts-ignore
        global.Moengage.add_email(email);
      }
    }
  }, [isAuthenticated, isProfileLoaded, isMoengageLoaded]);

  return null;
};
